import React from 'react';
import { Button, Col, Row } from 'react-bootstrap';

interface IncomingDeferralTabs {
    table: string;
    setTable: (...args: any) => void;
}

export default function IncomingDeferralTabs({ table, setTable }: IncomingDeferralTabs) {
    return (
        <Row className="justify-content-between mb-4 px-3">
            <Col xs="auto">
                <Button
                    className={`${table === 'offers' ? 'btn' : 'btn-outline-primary'} mr-4`}
                    onClick={() => setTable('offers')}
                >
                    Offers
                </Button>
                <Button
                    className={table !== 'offers' ? 'btn' : 'btn-outline-primary'}
                    onClick={() => setTable('contracts')}
                >
                    Contracts
                </Button>
            </Col>
        </Row>
    );
}
